module.exports = __webpack_public_path__ + "img/doe-logo.00c09e4a.png";